/**
 * Push notification types and payload definitions.
 *
 * These types are shared between the server (which sends push notifications)
 * and the mobile app (which receives them). The `PushNotificationType` enum
 * enables per-type opt-in/opt-out at the user level.
 */
/** Discriminated notification types for push notifications. */
export const PushNotificationType = {
    /** A user has been invited to participate in an admission form. */
    AdmissionParticipationRequest: "admission-participation-request",
    /** A user has been asked to complete or amend a form. */
    FormCompletionRequest: "form-completion-request",
    /** A form the user is involved in has been signed/completed. */
    FormSigned: "form-signed",
    /** A participation request has been declined by the recipient. */
    RequestDeclined: "request-declined",
    /** A Section 12 doctor has been invited to an assessment (interview). */
    Section12AssessmentInvite: "section-12-assessment-invite",
    /** A doctor has been asked to complete part 2 of a joint medical recommendation. */
    JointMedRecPart2Request: "joint-med-rec-part2-request",
};
/** All known notification type values — useful for validation and iteration. */
export const ALL_PUSH_NOTIFICATION_TYPES = Object.values(PushNotificationType);
//# sourceMappingURL=pushNotifications.js.map